import axios from 'axios'
import firebase from 'firebase'

/**
 * Post request to the cloud
 * @param {*} functionName
 * @param {*} object
 */
export function post(functionName, object) {
  console.log('posted object', object)
  return new Promise((resolve, reject) => {
    firebase.auth().currentUser.getIdToken().then(idToken => {

        axios({
          method: 'post',
          // url: 'api/' + functionName,
          url: 'https://tisaiot-api-dev.tisalabs.com/tisalabs-iot-platform-dev/us-central1/' + functionName,
          data: object,
          headers: {
            'Authorization': 'Bearer ' + idToken,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
          }
        }).then(success => {
          resolve(success.data)

        }).catch(error => {
          console.error('request failed when calling the cloud function ', functionName, 'Error:', error)
          reject(error)
        })
      })
      .catch(error => {
        console.log('error while getting the token ' + error)
      })

  })


}

// this should be used when calling a cloud function that has no payload
export function get(functionName) {
  return new Promise((resolve, reject) => {
    firebase.auth().currentUser.getIdToken().then(idToken => {
        axios({
          method: 'get',
          // url: 'api/' + functionName,
          url: 'https://tisaiot-api-dev.tisalabs.com/tisalabs-iot-platform-dev/us-central1/' + functionName,
          headers: {
            'Authorization': 'Bearer ' + idToken,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
          }
        }).then(success => {
          resolve(success.data)

        }).catch(error => {
          console.error('request failed when calling the cloud function ', functionName, 'Error:', error)
          reject(error)
        })
      })
      .catch(error => {
        console.log('error while getting the token ' + error)
      })

  })


}



// WEBPACK FOOTER //
// ./src/API/cloudFunctions.js